import { IntrospectionQuery, GraphQLObjectType, GraphQLInputObjectType } from 'graphql';
import GraphQLFieldsExtractor from './GraphQLFieldsExtractor';
import GraphQLIntrospection from './GraphQLIntrospection';

export default class PimcoreEntityIntrospection extends GraphQLIntrospection {
  constructor(
    introspection: IntrospectionQuery,
    private entityName: string,
    private graphQLFieldsExtractor: GraphQLFieldsExtractor,
  ) {
    super(introspection);
    if (!PimcoreEntityIntrospection.isCapitalized(entityName)) throw new Error('Entity name is not capitalized!');
  }

  private static isCapitalized(name = '') {
    if (!name.length) return false;
    const firstChar = name[0];
    return firstChar !== firstChar.toLowerCase();
  }

  get entity() {
    return this.entityName;
  }

  set entity(name: string) {
    if (!PimcoreEntityIntrospection.isCapitalized(name)) throw new Error('Entity name is not capitalized!');
    this.entityName = name;
  }

  get entityType() {
    const typeName = `object_${this.entityName}`;
    return this.getObjectTypeBy(typeName);
  }

  get mutationEntityType() {
    const typeName = `Update${this.entityName}Input`;
    return this.getObjectTypeBy(typeName);
  }

  get entityMutations() {
    return this.mutations.filter((m) => m.name.includes(this.entityName));
  }


  get queryFields() {
    return this.graphQLFieldsExtractor.extractFrom(this.entityType);
  }

  get mutationFields() {
    return this.graphQLFieldsExtractor.extractFrom(this.mutationEntityType);
  }

  private getObjectTypeBy(typeName: string) {
    const type = this.graphQLSchema.getType(typeName);
    return this.throwErrorIfNotObjectType(type, 'entityType');
  }

  private throwErrorIfNotObjectType(type: unknown, typeName: string) {
    if (!(type instanceof GraphQLObjectType || type instanceof GraphQLInputObjectType)) {
      throw Error(`${typeName} isn't object type!`);
    }

    return type;
  }

  get entityListingQuery() {
    const queries = this.graphQLSchema.getQueryType()?.getFields();
    if (!queries) throw new Error('GraphQLQueries is not retrieved!');
    return queries[this.entityListingQueryName];
  }

  get entityListingQueryName() {
    return `get${this.entityName}Listing`;
  }
}
